import { Box, BoxProps } from "@mui/material";
import React from "react";
import styled from "styled-components";

type Props = {

} & BoxProps;

const IMPage = ({ sx, children, ...rest }: Props) => {
	return (
		<Box sx={{
			width: "100vw",
			height: "100vh",
			'@supports (height: 100dvh)': {
				height: '100dvh',
			},
			display: "flex",
			flexDirection: "column",
			overflow: 'hidden',
			backgroundColor: "#000000",
			...sx
		}} {...rest}>
			{children}
		</Box>
	);
};

export default IMPage;
